import { Bases } from "@/utils/enum"

const INTERWAY_LIMIT = 20
const PRIME01_LIMIT = 80

export const isInterwayBase = (base: string) =>
	[Bases.INTERWAY, Bases.INTERWAYPR, Bases.INTERWAYSC].includes(base as Bases)

export const getCommissionLimitByBase = (base: string) =>
	isInterwayBase(base) ? INTERWAY_LIMIT : PRIME01_LIMIT
